import { render, staticRenderFns } from "./CourseLevelUp.vue?vue&type=template&id=61864ef0&scoped=true&"
import script from "./CourseLevelUp.vue?vue&type=script&lang=js&"
export * from "./CourseLevelUp.vue?vue&type=script&lang=js&"
import style0 from "./CourseLevelUp.vue?vue&type=style&index=0&id=61864ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61864ef0",
  null
  
)

export default component.exports